import React, { useEffect } from "react";
import MiniGamePageHome from "../Home";
import API_PATH from "../../../../config/API_PATH";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  setDataPopupError,
  setOpenPopupGivePiece,
} from "../../../../Redux/futures/mini-game/action";
import { TYPE_GIVE_PIECE } from "../../../../helper/const";
import { curStateAccount } from "../../../../Redux/selector";
import _ from "lodash";
import { getDataApi } from "../../../../config/service";

export default function ComponentInvite({ isShowPopupLogin }) {
  const { id } = useParams();
  const selectorAccount = useSelector(curStateAccount);

  const dispatch = useDispatch();

  const handleCheckParam = async () => {
    const dataGetLink = await getDataApi(
      `${API_PATH.miniGameGetCodeInviteLinkInfo}?code=${id}`
    );

    if (!dataGetLink?.data?.referral || !dataGetLink?.success) {
      return dispatch(
        setDataPopupError({
          isOpen: true,
          message: dataGetLink?.message || "",
        })
      );
    }
    // show popup confirm invite user
    dispatch(
      setOpenPopupGivePiece({
        isShow: true,
        link: "",
        type: TYPE_GIVE_PIECE.confirmInviteUser,
        data: dataGetLink?.data,
      })
    );
  };

  useEffect(() => {
    if (!isShowPopupLogin && !_.isEmpty(selectorAccount?.userInfo)) {
      handleCheckParam();
    }
  }, [selectorAccount?.userInfo, isShowPopupLogin]);
  return <MiniGamePageHome />;
}
